import { axios, addHeader } from '@/api/index.js'

const billHistory = {
  async searchBill(payload, accessToken) {
    return await axios.post('/billhistory/searchBill', payload, addHeader(accessToken, 15000))
  },
  async downloadBill(payload, accessToken) {
    return await axios.post('/billhistory/downloadBill', payload, addHeader(accessToken, 15000, 'blob'))
  },
  async downloadMultipleBills(payload, accessToken) {
    return await axios.post('/billhistory/downloadMultipleBills', payload, addHeader(accessToken, 15000, 'blob'))
  },
}

export default billHistory
